import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState, useEffect } from 'react';
import { inView } from '../render/dom/viewport/index.mjs';

function useInView(ref) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      root = _ref.root,
      margin = _ref.margin,
      amount = _ref.amount,
      _ref$once = _ref.once,
      once = _ref$once === void 0 ? false : _ref$once;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isInView = _useState2[0],
      setInView = _useState2[1];

  useEffect(function () {
    if (!ref.current || once && isInView) return;

    var onEnter = function onEnter() {
      setInView(true);
      return once ? undefined : function () {
        return setInView(false);
      };
    };

    var options = {
      root: root && root.current || undefined,
      margin: margin,
      amount: amount
    };
    return inView(ref.current, onEnter, options);
  }, [root, ref, margin, once]);
  return isInView;
}

export { useInView };